import { Box, useTheme } from '@mui/material'
import { FlexBox, NavigationRow } from 'components/atoms'
import { ReactNode } from 'react'
import { useBetContext } from 'contexts/BetContext'
import { HorseRacingExtentedInfo } from '@pturf-betin/betin-models-lib'

export const RaceSelector = ({ children }: { children?: ReactNode }) => {
    const theme = useTheme()
    const { race, upcomingEvents, loadRaceData, handleTrackingEvent } =
        useBetContext()

    const rowProps = {
        selectedMeetingNumber: race?.cNumber,
        selectedRaceNumber: race?.nb,
        selectedSpecialty: (race?.exInf as HorseRacingExtentedInfo)?.raceInfo
            ?.specialty,
        selectedDateTime: race?.stDt
    }

    const onMeetingChange = (meetingNumber: number) => {
        const event = upcomingEvents?.find(
            (event) => event.cNumber === meetingNumber.toString()
        )
        if (!event) return

        void handleTrackingEvent({
            eventType: 'NAVIGATION',
            actionType: 'MEETING'
        })
        void loadRaceData(event.id, event?.d)
    }

    const onRaceChange = (raceNumber: number) => {
        const event = upcomingEvents?.find(
            (event) =>
                event.nb === raceNumber.toString() &&
                event.cNumber === race?.cNumber
        )
        if (!event) return

        void handleTrackingEvent({
            eventType: 'NAVIGATION',
            actionType: 'RACE'
        })
        void loadRaceData(event.id, event?.d)
    }

    return (
        <Box
            sx={{
                width: 'fill-available',
                p: 2,
                backgroundColor: '#F4F6FA',
                borderRadius: theme.spacing(1)
            }}
        >
            <NavigationRow
                upcomingEvents={upcomingEvents}
                onClick={onMeetingChange}
                {...rowProps}
            />
            {race?.nb && (
                <NavigationRow
                    upcomingEvents={upcomingEvents}
                    rowType="RACE"
                    onClick={onRaceChange}
                    {...rowProps}
                    sx={{ mt: 2 }}
                />
            )}
            <FlexBox
                sx={{
                    width: 'fill-available',
                    justifyContent: 'center'
                }}
            >
                {children}
            </FlexBox>
        </Box>
    )
}
